import { useColumnDndContext } from '../ColumnDndProvider';
export const useColumnColors = (hovered, collapsed) => {
  const {
    isDraggingOver,
    draggingFromThisWith
  } = useColumnDndContext();
  const isDraggingOverDifferentColumn = isDraggingOver && !draggingFromThisWith;
  if (hovered && collapsed) {
    return {
      columnBackgroundColor: 'fill-field-hover',
      columnBodyColor: 'fill-field-hover'
    };
  }
  if (hovered) {
    return {
      columnBackgroundColor: 'fill-field-hover',
      columnBodyColor: 'fill-surface-recessed'
    };
  }
  if (collapsed) {
    return {
      columnBackgroundColor: isDraggingOverDifferentColumn ? 'fill-field-hover' : 'fill-field-default',
      columnBodyColor: isDraggingOverDifferentColumn ? 'fill-field-hover' : 'fill-field-default'
    };
  }
  return {
    columnBackgroundColor: 'fill-field-default',
    columnBodyColor: isDraggingOverDifferentColumn ? 'fill-field-hover' : 'fill-surface-recessed'
  };
};